import React, { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, Outlet, useLocation } from 'react-router-dom'
import AnalyticsService from './services/AnalyticsService'
import Home from './pages/Home'
import Sobre from './pages/Sobre'
import Projetos from './pages/Projetos'
import Contato from './pages/Contato'
import Transparencia from './pages/Transparencia'
import CircuitoPaulistaHipHop from './pages/CircuitoPaulistaHipHop'
import CircuitoCidade from './pages/CircuitoCidade'
import SemanaHipHop from './pages/SemanaHipHop'
import SemanaHipHopEdicao from './pages/SemanaHipHopEdicao'
import Header from './components/Header'
import Footer from './components/Footer'
import circuitoEdicoes from './data/circuitoEdicoes'
import semanaEdicoes from './data/semanaEdicoes'
import './App.css';

function App() {
  const circuitoCidadeRoutes = circuitoEdicoes.flatMap((edicao, edicaoIndex) => (
    edicao.cidades.map((cidade, cidadeIndex) => ({
      page: {
        id: 7 + (edicaoIndex * 10) + cidadeIndex,
        name: `${cidade.nome} - ${edicao.ano}`,
        path: `/projetos/circuito-paulista-hip-hop/${edicao.slug}/${cidade.slug}`,
        content: <CircuitoCidade edicao={edicao} cidade={cidade} />
      }
    }))
  ))

  const semanaEdicoesRoutes = semanaEdicoes.map((edicao) => ({
    page: {
      id: 200 + edicao.id,
      name: `${edicao.titulo} - Semana do Hip Hop de Bauru`,
      path: `/projetos/semana-do-hip-hop/${edicao.slug}`,
      content: <SemanaHipHopEdicao edicao={edicao} />
    }
  }))

  const routes = [
    {
      page: {
        id: 1,
        name: 'Home',
        path: '/',
        content: <Home />
      }
    },
    {
      page: {
        id: 2,
        name: 'Quem Somos',
        path: '/quem-somos',
        content: <Sobre />
      }
    },
    {
      page: {
        id: 3,
        name: 'Projetos',
        path: '/projetos',
        content: <Projetos />
      }
    },
    {
      page: {
        id: 4,
        name: 'Contato',
        path: '/contato',
        content: <Contato />
      }
    },
    {
      page: {
        id: 300,
        name: 'Transparência',
        path: '/transparencia',
        content: <Transparencia />
      }
    },
    {
      page: {
        id: 5,
        name: 'Circuito Paulista de Hip Hop',
        path: '/projetos/circuito-paulista-hip-hop',
        content: <CircuitoPaulistaHipHop />
      }
    },
    {
      page: {
        id: 6,
        name: 'Semana do Hip Hop de Bauru',
        path: '/projetos/semana-do-hip-hop',
        content: <SemanaHipHop />
      }
    },
    ...circuitoCidadeRoutes,
    ...semanaEdicoesRoutes
  ]

  useEffect(() => {
    AnalyticsService.initialize();
  }, [])
  
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route element={<DefaultLayout />}>
          {routes.map((route) => (
            <Route key={route.page.path} path={route.page.path} element={route.page.content} />
          ))}
        </Route>
      </Routes>
    </Router>
  );
}

function DefaultLayout() {
  const { pathname, state } = useLocation()

  useEffect(() => {
    if (state?.scrollTargetId) {
      return
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [pathname, state?.scrollTargetId])

  return (
    <>
      <Header />
        <main>
          <Outlet />
        </main>
      <Footer />
    </>
  )
}

export default App;
